import {Optional} from '@logistics-frontend/types'
import {
  applySpec,
  defaultTo,
  firstOf,
  flow,
  get,
  merge,
  pipe,
  stubArray,
  toDefaultEmptyString,
} from '@logistics-frontend/utils'
import {toPoint} from '@yandex-taxi/react-integration-api'

import {PointAddress, SuggestAddress} from 'src/shared/types'

const _fromSuggestToPointAddress: (suggestObject: Optional<SuggestAddress>) => SuggestAddress =
  applySpec<SuggestAddress>({
    coordinates: flow(get('pos'), toPoint),
    shortName: flow(get('title.text'), toDefaultEmptyString),
    city: flow(get('city'), toDefaultEmptyString),
    street: flow(get('street'), toDefaultEmptyString),
    building: flow(get('house'), toDefaultEmptyString),
    porch: flow(get('porchnumber'), toDefaultEmptyString),
    floor: flow(get('floor_number'), toDefaultEmptyString),
    flat: flow(get('quarters_number'), toDefaultEmptyString),
    doorCode: flow(get('doorphone_number'), toDefaultEmptyString),
    uri: flow(get('uri'), toDefaultEmptyString),
    country: get('country'),
    comment: get('comment'),
    contact: get('contact'),
    _photos: flow(get('address.photos'), defaultTo(stubArray())),
  })

const getAddressName: (suggestObject?: SuggestAddress) => string = flow(
  firstOf(get('title.text'), get('text')),
  toDefaultEmptyString,
)

export const fromSuggestToPointAddress = (suggestObject?: SuggestAddress): PointAddress => {
  // В Suggest подмешаны сохраненные пользователем адреса. Для таких адресов актуальный адрес хранится в subtitle.text
  const fullName = get('isSavedAddress', suggestObject)
    ? pipe(suggestObject, get('subtitle.text'), toDefaultEmptyString)
    : pipe(suggestObject, getAddressName)

  return merge(_fromSuggestToPointAddress(suggestObject), {
    fullName,
  })
}
